import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { COPY } from '../../contracts/copyMap';
import { ROUTES } from '../../contracts/routes';

// Fixed bottom tab bar — the only navigation chrome signed-out visitors see.
// Mounted ONCE by PublicShell (the public layout route); pages never render
// it themselves. Mirrors the in-app BottomTabBar position; hosts reserve its
// 60px height with bottom padding so content clears the bar. Translucent
// over black (same treatment as FooterFeatureStrip) so it reads identically
// over the hero portrait and over solid-obsidian content pages.
//
// `activePrefix` marks the tab current for every path under it — LEGAL stays
// lit on both /legal/terms and /legal/privacy.
const CONTENT_TABS = [
  { label: COPY.PUBLIC_NAV_ABOUT, to: ROUTES.ABOUT, activePrefix: ROUTES.ABOUT },
  { label: COPY.PUBLIC_NAV_FAQ, to: ROUTES.FAQ, activePrefix: ROUTES.FAQ },
  { label: COPY.PUBLIC_NAV_CONTACT, to: ROUTES.CONTACT, activePrefix: ROUTES.CONTACT },
  // LEGAL lands on the terms doc; the page cross-links to privacy.
  { label: COPY.PUBLIC_NAV_LEGAL, to: ROUTES.LEGAL_TERMS, activePrefix: ROUTES.LEGAL },
];

const PublicNav = () => {
  const { pathname } = useLocation();
  // Signed-in visitors get a way back into the app instead of a SIGN IN tab
  // that would bounce through the sign-in redirect. useAuth() is undefined
  // outside AuthProvider (unit tests) — treat that as signed out.
  const { userLoggedIn } = useAuth() || {};
  const tabs = [
    ...CONTENT_TABS,
    userLoggedIn
      ? { label: COPY.PUBLIC_NAV_OPEN_APP, to: ROUTES.HOME, activePrefix: ROUTES.HOME }
      : { label: COPY.PUBLIC_NAV_SIGN_IN, to: ROUTES.SIGN_IN, activePrefix: ROUTES.SIGN_IN },
  ];
  return (
    <nav
      aria-label="Site"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-hairline-soft bg-[rgba(0,0,0,0.88)] pb-safe-bottom"
    >
      <div className="mx-auto flex h-[60px] w-full max-w-[640px] items-center justify-around px-4">
        {tabs.map((tab) => {
          const isActive = pathname === tab.activePrefix
            || pathname.startsWith(`${tab.activePrefix}/`);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              aria-current={isActive ? 'page' : undefined}
              className={[
                'font-display uppercase text-[11px] sm:text-[12px] tracking-[0.14em] sm:tracking-[0.2em] whitespace-nowrap no-underline transition-colors',
                isActive ? 'text-aurum' : 'text-bone-dim hover:text-bone',
              ].join(' ')}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default PublicNav;
